import React, { useState, useEffect } from "react";
import { API_BASE_URL } from "../../config";

// const API_BASE_URL = "https://screening.fanisko.com";
// const API_BASE_URL = "http://127.0.0.1:8000";

const editModalStyle = {
  background: "#fff",
  borderRadius: 17,
  padding: "40px 48px 40px 48px",
  width: "98vw",
  maxWidth: 1500,
  minWidth: 900,
  boxShadow: "0 8px 44px #387be855",
  position: "relative",
  display: "flex",
  flexDirection: "column",
  fontFamily: "'Segoe UI','Roboto',Arial,sans-serif"
};


const overlayy = {
  position: "fixed",
  top: 0, left: 0, right: 0, bottom: 0,
  background: "rgba(0,0,0,0.22)",
  zIndex: 1100,
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "center",
  height: "100vh",
  minHeight: "100vh",
  overflowY: "auto",
  paddingTop: 0
};
// --- Modal Display (from your modal code) ---
const overlay = {
  position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
  background: "rgba(0,0,0,0.22)", zIndex: 1100,
  display: "flex", alignItems: "flex-start", justifyContent: "center",
  overflowY: "auto",
  paddingTop: "38px"
};
const modal = {
  background: "#fff", borderRadius: 10, padding: 30,
  width: "95vw", maxWidth: 1000,
  // REMOVE: maxHeight, overflowY, height
  boxShadow: "0 6px 30px #387be83a",
  position: "relative",
  fontFamily: "'Segoe UI','Roboto',Arial,sans-serif"
};
const headingStyle = { margin: "15px 0 7px 0", color: "rgba(2, 52, 137, 1)", fontWeight: 700, fontSize: "1em" };
const labelStyle = { color: "rgba(2, 52, 137, 1)", fontWeight: 700, fontSize: "1em" };
const valueStyle = { color: "#2a3560", fontWeight: 500 };
const label = { color: "#358", fontWeight: 700, fontSize: "1.08em" };
const value = { color: "#2a3560", fontWeight: 500 };
const ul = { paddingLeft: 16, marginBottom: 0 };

function listSection(arr) {
  if (!arr) return null;
  if (typeof arr === "string" && arr.trim().length === 0) return null;
  if (Array.isArray(arr) && arr.length === 0) return null;

  const items = Array.isArray(arr) ? arr : [arr];
  return <ul style={ul}>{items.map((s, i) =>
    typeof s === "string" && s.trim().length > 0 ?
      <li key={i} style={{ marginBottom: 6 }}>{s}</li> : null
  )}</ul>;
}

/** Utility to display a string with \\n as bullet list items */
function linesToList(val) {
  if (!val) return null;
  let text = '';

  if (Array.isArray(val)) {
    // Join array elements into a single string separated by space or newline
    text = val.join(' ');
  } else if (typeof val === 'string') {
    text = val;
  } else {
    return null;
  }

  // Replace literal \n sequences with actual newlines
  const replaced = text.replace(/\\n/g, '\n');

  // Split by newlines and trim
  const points = replaced.split('\n').map(s => s.trim()).filter(s => s.length > 0);

  if (points.length === 0) return null;

  return (
    <ul style={ul}>
      {points.map((pt, i) => <li key={i} style={{ marginBottom: 6 }}>{pt}</li>)}
    </ul>
  );
}

function renderMultilineField(field) {
  if (!field) return null;

  const isArray = Array.isArray(field);
  const text = isArray ? field.join(' ') : field;

  // Check if text contains literal \n sequences or real new lines
  if (typeof text === 'string' && (text.includes('\\n') || text.includes('\n'))) {
    // Use linesToList to split by newlines and render bullet points
    return linesToList(field);
  } else {
    // Otherwise render as plain list (array or single string)
    return listSection(field);
  }
}

const showLine = (labelText, valueText) => (
  valueText && String(valueText).trim().length > 0 ?
    <div style={{ marginBottom: 8 }}>
      <span style={label}>{labelText}: </span>
      <span style={value}>{valueText}</span>
    </div>
    : null
);

function JobDetailsModal({ job, onClose }) {
  if (!job) return null;

  // Get sectionWeightage entries as an array of [name, percent]
  const sectionEntries = job.sectionWeightage
    ? Object.entries(job.sectionWeightage)
    : [];

  return (
    <div style={overlay} onClick={onClose}>
      <div
        style={{
          ...modal,
          display: 'flex',
          flexDirection: 'row',
          gap: 32,
          minWidth: 440
        }}
        onClick={e => e.stopPropagation()}
      >
        {/* Left: Job Details */}
        <div style={{ flex: 1, minWidth: 0 }}>
          <span
            style={{
              position: "absolute", top: 19, right: 19, fontSize: 19,
              color: "#93aac7", cursor: "pointer"
            }}
            onClick={onClose}
          >×</span>
          <h2 style={{ margin: "5px 0 7px 0", color: "#2a3560", fontWeight: 700, fontSize: "26px" }}>
            {job.jobrole || job.title || job.jobTitle}
          </h2>
          {showLine("Job ID", job.jobid)}

          {(job.jobDescription || job.jd) && (
            <>
              {console.log("Job Description original:", job.jobDescription || job.jd)}
              <div style={headingStyle}>Job Description:</div>
              {renderMultilineField(job.jobDescription || job.jd)}
            </>
          )}

          {(job.educationalQualifications || job.qualifications) && (
            <>
              {console.log("Educational Qualifications original:", job.educationalQualifications || job.qualifications)}
              <div style={headingStyle}>Educational Qualifications:</div>
              {renderMultilineField(job.educationalQualifications || job.qualifications)}
            </>
          )}

          <br></br>

          {(job.experienceRequired || job.experience) && (
            <>
              {console.log("Experience Required original:", job.experienceRequired || job.experience)}
              <div style={headingStyle}>Experience Required:</div>
              {renderMultilineField(job.experienceRequired || job.experience)}
            </>
          )}

          {job.desiredSkills && job.desiredSkills.length > 0 && (
            <>
              {console.log("Desired Skills original:", job.desiredSkills)}
              <div style={headingStyle}>Desired Skills:</div>
              {renderMultilineField(job.desiredSkills)}
            </>
          )}

          {job.requiredCertifications && job.requiredCertifications.length > 0 && (
            <>
              {console.log("Required Certifications original:", job.requiredCertifications)}
              <div style={headingStyle}>Required Certifications:</div>
              {renderMultilineField(job.requiredCertifications)}
            </>
          )}

          {job.goodToHave && job.goodToHave.length > 0 && (
            <>
              {console.log("Good to Have original:", job.goodToHave)}
              <div style={headingStyle}>Good to Have:</div>
              {renderMultilineField(job.goodToHave)}
            </>
          )}
          <br></br>
          {showLine("Employment Type", job.employmentType)}
          {showLine(
            "Work Mode",
            Array.isArray(job.workMode)
              ? job.workMode.join(", ")
              : job.workMode
          )}

          {showLine(
            "Job Location",
            Array.isArray(job.location)
              ? job.location.join(", ")
              : job.location || job.jobLocation
          )}

          {showLine("Joining Requirement", job.joiningRequirement || job.requiredBy)}

          {showLine("Salary Package", job.salaryPackage)}
          <br></br>
          <br></br>
        </div>
        {/* Right: Section Weightage */}
        <div style={{
          flex: 0.7,
          minWidth: 180,
          borderLeft: "1.2px solid #e5eafd",
          paddingLeft: 32,
          paddingTop: 10
        }}>
          <h4 style={{ marginBottom: 10, fontWeight: 800, color: "#2175f5" }}>Section Weightage:</h4>
          {sectionEntries.length > 0 ? (
            <table style={{
              width: "100%",
              borderCollapse: "collapse",
              marginBottom: 10,
              border: "1px solid #e0e7ef" // outer border for table
            }}>
              <tbody>
                {sectionEntries.map(([name, pct]) => (
                  <tr key={name}>
                    <td style={{
                      padding: "5px 7px",
                      color: "#233764",
                      fontWeight: 600,
                      border: "1px solid #e0e7ef" // vertical and horizontal lines
                    }}>
                      {name}
                    </td>
                    <td style={{
                      padding: "2px 20px",
                      color: "#2175f5",
                      fontWeight: 700,
                      border: "1px solid #e0e7ef" // vertical and horizontal lines
                    }}>
                      {pct}%
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <span style={{ color: "#888" }}>No section weightage data.</span>
          )}
        </div>
      </div>
    </div>
  );
}

// Main ViewJobs component

export default function ViewJobs({ onEditJob, onToggleVisibility }) {
  const [jobs, setJobs] = useState([]);
  const [editJob, setEditJob] = useState(null);      // store the actual job object
  const [viewJob, setViewJob] = useState(null);
  const [loading, setLoading] = useState(true); // NEW
  async function toggleShow(job) {
    const newShow = job.show === "on" ? "off" : "on";
    try {
      const res = await fetch(`${API_BASE_URL}/api/jobview/${job.jobid || job._id}/show`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ show: newShow })
      });
      if (!res.ok) throw new Error("Failed to update show status");
      await fetchJobs(); // refresh list with updated data
    } catch (err) {
      console.error("Error toggling show:", err);
    }
  }

  async function fetchJobs() {
    setLoading(true); // Set loading at start
    try {
      const res = await fetch(`${API_BASE_URL}/api/jobview`);
      const data = await res.json();
      setJobs(data);
    } catch (err) {
      console.error("Failed to fetch jobs", err);
    }
    setLoading(false); // Regardless of success or failure, loading ends
  }
  useEffect(() => {
    fetchJobs();
  }, []);

  useEffect(() => {
    if (editJob) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    // cleanup in case component unmounts while open
    return () => {
      document.body.style.overflow = "";
    };
  }, [editJob]);

  return (
    <div style={{ padding: "32px" }}>
      <h2 style={{ marginBottom: "26px", color: "#1d2542", fontWeight: 800 }}>View All Jobs</h2>
      {loading ? (
        <div style={{ fontSize: 18, color: "#2373f0", fontWeight: 500 }}>Loading jobs...</div>
      ) : jobs.length === 0 ? (
        <div>No jobs posted yet.</div>
      ) : (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(2, 1fr)",
            gap: "32px 24px",
          }}
        >
          {jobs.map((job) => (
            <div
              key={job.id || job.jobid || job._id}
              style={{
                border: "1.8px solid #e2e9f8",
                borderRadius: 16,
                background: "#fff",
                boxShadow: "0 4px 16px #407be815",
                minHeight: "120px",
                padding: "28px 28px 24px 28px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                fontFamily: "'Segoe UI','Roboto',Arial,sans-serif",
                position: "relative"
              }}
            >
              {/* Title and Job ID - floated to top */}
              <div style={{ marginBottom: 7 }}>
                <div
                  style={{
                    fontSize: 22,
                    fontWeight: 700,
                    color: "#173679",
                    lineHeight: 1.22,
                    overflowWrap: "break-word",  // wrap long words
                    wordWrap: "break-word",
                    whiteSpace: "normal",         // allow wrapping
                    maxWidth: "calc(100% - 70px)" // leave space for toggle on right
                  }}
                >
                  {job.jobrole || job.title || job.jobTitle}
                </div>
                <div style={{ color: "#5363a4", fontWeight: 700, fontSize: 15, letterSpacing: 0.3, marginTop: 1 }}>
                  Job ID: {job.jobid}
                </div>
              </div>
              {/* Control bar always aligned horizontally */}
              <div style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: "18px",
                marginTop: "14px"
              }}>
                <button
                  onClick={() => setViewJob(job)}
                  style={{
                    background: "#2175f5",
                    color: "#fff",
                    border: "none",
                    borderRadius: "8px",
                    padding: "11px 30px",
                    fontSize: "1.05rem",
                    fontWeight: 700,
                    boxShadow: "0 0 3px #2175f522",
                    outline: "none",
                    transition: "background .2s",
                    cursor: "pointer"
                  }}
                >
                  View Details
                </button>
                <button
                  onClick={() => setEditJob(job)}
                  style={{
                    background: "#fff",
                    border: "1.5px solid #dde6f2",
                    borderRadius: "8px",
                    padding: "11px 30px",
                    fontSize: "1.05rem",
                    fontWeight: 700,
                    color: "#2a3560",
                    boxShadow: "0 0 1px #dde6f2",
                    outline: "none",
                    cursor: "pointer"
                  }}
                >
                  Edit
                </button>
                <button
                  onClick={() => toggleShow(job)}
                  aria-label={`Toggle show for ${job.jobrole}`}
                  style={{
                    width: 50,
                    height: 28,
                    marginTop: -165,
                    marginLeft: 180,
                    borderRadius: 14,
                    backgroundColor: job.show === "on" ? "#23a262" : "#ccc",  // changed to green here
                    border: "none",
                    cursor: "pointer",
                    position: "relative",
                    outline: "none"
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      top: 3,
                      left: job.show === "on" ? 26 : 4,
                      width: 20,
                      height: 20,
                      borderRadius: "50%",
                      backgroundColor: "white",
                      transition: "left 0.3s"
                    }}
                  />
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
      {viewJob && <JobDetailsModal job={viewJob} onClose={() => setViewJob(null)} />}
      {editJob && (
        <div style={overlayy}>
          <div style={editModalStyle}>
            <EditJobForm
              job={editJob}
              onSave={async updatedJob => {
                await fetchJobs(); // fetch latest jobs after update
                setEditJob(null);  // close the modal
              }}
              onCancel={() => setEditJob(null)}
            />
          </div>
        </div>
      )}
    </div>
  );
}


function EditJobForm({ job, onSave, onCancel }) {
  const [generating, setGenerating] = useState(false);
  async function handleGenerateJobFields() {
    if (!form.jobTitle || !form.jobTitle.trim()) return;
    setGenerating(true);
    try {
      const resp = await fetch(`${API_BASE_URL}/api/generate-job-description`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ job_title: form.jobTitle }),
      });
      if (!resp.ok) throw new Error("Failed to generate job description");
      const data = await resp.json();

      setForm(f => ({
        ...f,
        jobDescription: data["Job Description"] || "",
        educationalQualifications: data["Educational Qualifications"] || "",
        experienceRequired: data["Experience Required"] || "",
        desiredSkills: data["Desired Skills"] || "",
        goodToHave: data["Good to Have"] || "",
      }));
    } catch (err) {
      alert("Error generating job description: " + (err.message || err));
    } finally {
      setGenerating(false);
    }
  }

  // Helper to turn sections object into array, and vice versa
  function fromSectionWeightage(obj) {
    if (!obj) return [];
    return Object.entries(obj).map(([section, weightage]) => ({
      section,
      weightage: Number(weightage)
    }));
  }
  function toSectionWeightage(arr) {
    const obj = {};
    arr.forEach(({ section, weightage }) => {
      if (section.trim() !== "") obj[section] = Number(weightage);
    });
    return obj;
  }

  // Prefill forms
  const [form, setForm] = useState({
    jobTitle: job.jobTitle || job.jobrole || "",
    jobrole: job.jobrole || job.jobTitle || "",
    jobDescription: Array.isArray(job.jobDescription) ? job.jobDescription.join("\n") : (job.jobDescription || ""),
    educationalQualifications: Array.isArray(job.educationalQualifications) ? job.educationalQualifications.join("\n") : (job.educationalQualifications || ""),
    experienceRequired: job.experienceRequired || "",
    desiredSkills: Array.isArray(job.desiredSkills) ? job.desiredSkills.join("\n") : (job.desiredSkills || ""),
    requiredCertifications: Array.isArray(job.requiredCertifications) ? job.requiredCertifications.join("\n") : (job.requiredCertifications || ""),
    goodToHave: Array.isArray(job.goodToHave) ? job.goodToHave.join("\n") : (job.goodToHave || ""),
    employmentType: job.employmentType || "",
    workMode: Array.isArray(job.workMode) ? job.workMode : [],
    location: Array.isArray(job.location) ? job.location : [],
    joiningRequirement: job.joiningRequirement || "",
    salaryPackage: job.salaryPackage || ""
  });

  // Section Weightages (right column)
  const [sections, setSections] = useState(fromSectionWeightage(job.sectionWeightage));
  const [cityInput, setCityInput] = useState("");
  const [workModes, setWorkModes] = useState(form.workMode);
  const [posting, setPosting] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  // Update form fields (left)
  function handleChange(e) {
    const { name, value } = e.target;
    setForm((f) => ({
      ...f,
      [name]: value
    }));
  }

  function handleAddCity() {
    const trimmed = cityInput.trim();
    if (trimmed && !form.location.includes(trimmed)) {
      setForm(f => ({ ...f, location: [...f.location, trimmed] }));
    }
    setCityInput("");
  }
  function handleRemoveCity(city) {
    setForm(f => ({ ...f, location: f.location.filter(c => c !== city) }));
  }

  // Work Mode handlers
  const allModes = ["Onsite", "Hybrid", "Remote"];
  function handleAddWorkMode(mode) {
    if (!form.workMode.includes(mode)) {
      setForm(f => ({ ...f, workMode: [...f.workMode, mode] }));
    }
  }
  function handleRemoveWorkMode(mode) {
    setForm(f => ({ ...f, workMode: f.workMode.filter(m => m !== mode) }));
  }

  // Section Weightage handlers
  function handleSectionChange(idx, key, value) {
    setSections(sections =>
      sections.map((s, i) =>
        i === idx ? { ...s, [key]: key === "weightage" ? Number(value) : value } : s
      )
    );
  }
  function handleAddSection() {
    setSections(sections => [...sections, { section: "", weightage: "" }]);
  }
  function handleRemoveSection(idx) {
    setSections(sections => sections.filter((_, i) => i !== idx));
  }

  async function handleSubmitJob() {
    setPosting(true);
    setError("");
    setSuccess("");

    const patchData = {
      ...job,
      jobrole: form.jobTitle,  // MongoDB field
      jobTitle: form.jobTitle, // optional frontend convenience
      jobDescription: form.jobDescription.split("\n").map(line => line.trim()).filter(Boolean),
      educationalQualifications: form.educationalQualifications.split("\n").map(line => line.trim()).filter(Boolean),
      experienceRequired: form.experienceRequired,
      desiredSkills: form.desiredSkills.split("\n").map(line => line.trim()).filter(Boolean),
      requiredCertifications: form.requiredCertifications.split("\n").map(line => line.trim()).filter(Boolean),
      goodToHave: form.goodToHave.split("\n").map(line => line.trim()).filter(Boolean),
      employmentType: form.employmentType,
      workMode: form.workMode,
      location: form.location,
      joiningRequirement: form.joiningRequirement,
      salaryPackage: form.salaryPackage,
      sectionWeightage: toSectionWeightage(sections),
    };

    try {
      // 1 - PATCH update main job record
      const patchResp = await fetch(`${API_BASE_URL}/api/jobview/${job.jobid || job._id}`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(patchData),
      });
      if (!patchResp.ok) throw new Error(`Update failed (${patchResp.status})`);

      // 2 - POST updated job data to JD parsing endpoint for JobDetailsV2 refresh
      const postResp = await fetch(`${API_BASE_URL}/api/upd/jobs`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(patchData),
      });
      if (!postResp.ok) throw new Error(`JD update failed (${postResp.status})`);

      setSuccess("Job and JD updated successfully!");
      setTimeout(() => onSave(patchData), 1200);

    } catch (err) {
      setError(String(err.message || err));
    } finally {
      setPosting(false);
    }
  }

  // Styles, same as your sample
  const inputStyle = {
    width: "95%",
    height: 40,
    fontSize: 15,
    borderRadius: 6,
    border: "1px solid #2782e2",
    padding: "0 12px",
    background: "#f7fbff"
  };
  const inputAreaStyle = {
    width: "95%",
    fontSize: 15,
    borderRadius: 6,
    border: "1px solid #2782e2",
    padding: "10px 12px",
    background: "#f7fbff"
  };
  const inputAreaStyleloc = {
    width: "90%",
    fontSize: 15,
    borderRadius: 6,
    border: "1px solid #2782e2",
    padding: "10px 12px",
    background: "#f7fbff"
  };
  const labelStyle = {
    fontWeight: 700,
    color: "#455e88",
    fontSize: 15,
    display: "block",
    marginBottom: 7
  };
  const helperStyle = {
    color: "#818fb1",
    fontSize: 13,
    marginBottom: 4
  };

  return (
    <div style={{
      background: "#ecf6fe",
      width: "100%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      boxSizing: "border-box",
      position: "relative"
    }}>
      <div
        onClick={onCancel}
        style={{
          position: "absolute",
          top: 18,
          right: 24,
          fontSize: 32,
          fontWeight: 700,
          color: "#000000ff",
          cursor: "pointer",
          zIndex: 1201,
          background: "none",
          border: "none",
          lineHeight: 1,
          padding: 0,
          transition: "color 0.16s"
        }}
        onMouseOver={e => (e.currentTarget.style.color = "#CA3040")}
        onMouseOut={e => (e.currentTarget.style.color = "#000000ff")}
        aria-label="Close"
      >
        ×
      </div>
      <div style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "flex-start",
        gap: 64,   // Increased from 40 or 32 for more gap between left/right
        width: "100%",
        maxWidth: 1300,
      }}>
        {/* Left side - attributes */}
        <div style={{
          flex: 2,                  // Increase from 1 to 2 for wider left
          background: "#fff",
          borderRadius: 13,
          marginTop: 40,
          boxShadow: "0 2px 16px #b3ddff20",
          padding: "40px 30px 40px 30px",
          marginleft: 0,
          minWidth: 340,
          maxWidth: 900             // Increase maxWidth for longer left panel if desired
        }}>
          <h2 style={{
            color: "#172d44",
            fontWeight: 700,
            fontSize: "2rem",
            marginBottom: 18
          }}>
            Edit Job
          </h2>
          {/* Job Title, Job Description, etc. */}
          <div style={{ marginBottom: 22 }}>
            <div style={{ display: "flex", alignItems: "center", marginBottom: 7 }}>
              <label style={labelStyle}>Job Title <span style={{ color: "red" }}>*</span></label>
              <button
                type="button"
                onClick={handleGenerateJobFields}
                disabled={generating}
                style={{
                  padding: "10px 28px",
                  fontWeight: "bold",
                  fontSize: "16px",
                  background: generating
                    ? "#b3b3b3"
                    : "linear-gradient(90deg, #3381e7ff 0%, #3ec6e7 100%)",
                  color: "white",
                  border: generating ? "2px solid #b3b3b3" : "2px solid #3381e7ff",
                  borderRadius: "25px",
                  cursor: generating ? "not-allowed" : "pointer",
                  boxShadow: generating
                    ? "none"
                    : "0 4px 14px 0 rgba(51, 129, 231, 0.15), 0 1.5px 4px rgba(50,198,231,.12)",
                  whiteSpace: "nowrap",
                  marginLeft: "auto",
                  transition: "background 0.3s, box-shadow 0.3s, border 0.3s",
                }}
                title="Generate Job Description"
              >
                {generating ? "Generating..." : "Generate"}
              </button>
            </div>
            <input
              type="text"
              name="jobTitle"
              value={form.jobTitle}
              onChange={handleChange}
              placeholder="Enter job title"
              style={inputStyle}
            />
          </div>
          <div style={{ marginBottom: 22 }}>
            <label style={labelStyle}>Job Description <span style={{ color: "red" }}>*</span></label>
            <div style={helperStyle}>Each line or bullet will be stored as a pointer.</div>
            <textarea
              name="jobDescription"
              value={form.jobDescription}
              onChange={handleChange}
              rows={5}
              placeholder="Describe the job role and responsibilities"
              style={inputAreaStyle}
            />
          </div>
          <div style={{ marginBottom: 22 }}>
            <label style={labelStyle}>Educational Qualifications <span style={{ color: "red" }}>*</span></label>
            <div style={helperStyle}>Each line or bullet will be stored as a pointer.</div>
            <textarea
              name="educationalQualifications"
              value={form.educationalQualifications}
              onChange={handleChange}
              rows={2}
              placeholder="Enter required qualifications"
              style={inputAreaStyle}
            />
          </div>
          <div style={{ marginBottom: 22 }}>
            <label style={labelStyle}>Experience Required <span style={{ color: "red" }}>*</span></label>
            <input
              type="text"
              name="experienceRequired"
              value={form.experienceRequired}
              onChange={handleChange}
              placeholder="Ex: 3+ years"
              style={inputStyle}
            />
          </div>
          <div style={{ marginBottom: 22 }}>
            <label style={labelStyle}>Desired Skills <span style={{ color: "red" }}>*</span></label>
            <div style={helperStyle}>Each skill on a new line or with a bullet.</div>
            <textarea
              name="desiredSkills"
              value={form.desiredSkills}
              onChange={handleChange}
              rows={2}
              placeholder="List desired skills"
              style={inputAreaStyle}
            />
          </div>
          <div style={{ marginBottom: 22 }}>
            <label style={labelStyle}>Required Certifications</label>
            <div style={helperStyle}>Each on a new line or with a bullet.</div>
            <textarea
              name="requiredCertifications"
              value={form.requiredCertifications}
              onChange={handleChange}
              rows={2}
              placeholder="List required certifications"
              style={inputAreaStyle}
            />
          </div>
          <div style={{ marginBottom: 22 }}>
            <label style={labelStyle}>Good to Have</label>
            <div style={helperStyle}>Each on a new line or with a bullet.</div>
            <textarea
              name="goodToHave"
              value={form.goodToHave}
              onChange={handleChange}
              rows={2}
              placeholder="Optional points"
              style={inputAreaStyle}
            />
          </div>
          <div style={{ marginBottom: 22 }}>
            <label style={labelStyle}>Employment Type <span style={{ color: "red" }}>*</span></label>
            <select
              name="employmentType"
              value={form.employmentType}
              onChange={handleChange}
              style={{ ...inputStyle, height: 40 }}
            >
              <option value="">Select</option>
              <option value="Contract">Contract</option>
              <option value="Full-Time Employment">Full-Time Employment</option>
              <option value="Part-Time Employment">Part-Time Employment</option>
              <option value="Internship">Internship</option>
            </select>
          </div>
          <div style={{ marginBottom: 22 }}>
            <label style={labelStyle}>Work Mode <span style={{ color: "red" }}>*</span></label>
            <div style={{ ...inputStyle, minHeight: 40, display: "flex", flexWrap: "wrap", gap: 6, alignItems: "center" }}>
              {form.workMode.map((mode) => (
                <div key={mode} style={{ background: "#d1f0e4", padding: "4px 10px", borderRadius: 14, display: "flex", alignItems: "center" }}>
                  <span style={{ marginRight: 8 }}>{mode}</span>
                  <button type="button" onClick={() => handleRemoveWorkMode(mode)} style={{ border: "none", background: "transparent", cursor: "pointer", fontWeight: "bold" }}>×</button>
                </div>
              ))}
              {allModes.filter(opt => !form.workMode.includes(opt)).map((mode) => (
                <button key={mode} type="button"
                  style={{
                    background: "#eef6fb",
                    color: "#2373f0",
                    border: "1px solid #2373f0",
                    borderRadius: 16,
                    padding: "2px 15px",
                    marginLeft: 8,
                    marginRight: 4,
                    cursor: "pointer",
                    fontWeight: "600",
                    display: "flex",
                    alignItems: "center"
                  }}
                  onClick={() => handleAddWorkMode(mode)}
                >
                  <span style={{ marginRight: 5 }}>{mode}</span>
                  <span style={{ fontWeight: "bold", marginTop: -5, fontSize: 20, color: "#2373f0" }}>＋</span>
                </button>
              ))}
            </div>
          </div>
          <div style={{ marginBottom: 22 }}>
            <label style={labelStyle}>Job Location <span style={{ color: "red" }}>*</span></label>
            <div style={{ ...inputAreaStyleloc, minHeight: 40, display: "flex", flexWrap: "wrap", gap: 6, alignItems: "center" }}>
              {form.location.map((city) => (
                <div key={city} style={{ background: "#cce4ff", padding: "4px 10px", borderRadius: 14, display: "flex", alignItems: "center" }}>
                  <span style={{ marginRight: 8 }}>{city}</span>
                  <button type="button" onClick={() => handleRemoveCity(city)} style={{ border: "none", background: "transparent", cursor: "pointer", fontWeight: "bold" }}>×</button>
                </div>
              ))}
              <input
                type="text"
                value={cityInput}
                onChange={(e) => setCityInput(e.target.value)}
                onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); handleAddCity(); } }}
                placeholder="Type city and press Enter"
                style={{ border: "none", outline: "none", flex: "1 0 120px", minWidth: 120 }}
              />
            </div>
          </div>
          <div style={{ marginBottom: 22 }}>
            <label style={labelStyle}>Joining Requirement</label>
            <input
              type="text"
              name="joiningRequirement"
              value={form.joiningRequirement}
              onChange={handleChange}
              placeholder="Ex: Immediate, 2 months, etc."
              style={inputStyle}
            />
          </div>
          <div style={{ marginBottom: 22 }}>
            <label style={labelStyle}>Salary Package</label>
            <input
              type="text"
              name="salaryPackage"
              value={form.salaryPackage}
              onChange={handleChange}
              placeholder="Ex: 8-12 LPA"
              style={inputStyle}
            />
          </div>
        </div>
        {/* RIGHT - Section Weightage */}
        <div style={{
          width: 430,
          background: "#fff",
          borderRadius: 13,
          boxShadow: "0 2px 16px #b3ddff20",
          padding: 40,
          marginTop: 620,
          marginRight: 0,
          height: "fit-content"
        }}>
          <h2 style={{
            color: "#172d44",
            fontWeight: 700,
            fontSize: "1.5rem",
            marginBottom: 18
          }}>
            Section Weightage
          </h2>
          {sections.map((sec, idx) => (
            <div key={idx} style={{ display: "flex", alignItems: "center", marginBottom: 16 }}>
              <input
                type="text"
                value={sec.section}
                placeholder="Section"
                onChange={e => handleSectionChange(idx, "section", e.target.value)}
                style={{
                  flex: "2 1 0",
                  padding: "10px 10px",
                  borderRadius: 6,
                  border: "1px solid #2782e2",
                  fontSize: 15,
                  background: "#fff"
                }}
              />
              <input
                type="number"
                value={sec.weightage}
                min={0}
                max={100}
                onChange={e => handleSectionChange(idx, "weightage", e.target.value)}
                style={{
                  width: 90,
                  marginLeft: 12,
                  padding: "10px 10px",
                  borderRadius: 6,
                  border: "1px solid #2782e2",
                  fontSize: 15,
                  background: "#f7fbff"
                }}
              />
              <button
                type="button"
                title="Remove"
                onClick={() => handleRemoveSection(idx)}
                style={{
                  marginLeft: 8,
                  background: "none",
                  border: "none",
                  color: "#e03c32",
                  fontSize: 20,
                  cursor: "pointer",
                  padding: 0
                }}
              >×</button>
            </div>
          ))}
          <button
            type="button"
            onClick={handleAddSection}
            style={{
              marginTop: 10,
              padding: "5px 15px",
              fontSize: 18,
              borderRadius: 6,
              border: "1.5px solid #2684ff",
              background: "#f7fbff",
              color: "#2684ff",
              cursor: "pointer"
            }}
          >
            ＋ Add Section
          </button>
        </div>
      </div>
      <div style={{ marginTop: 40, textAlign: "center" }}>
        {error && <div style={{ color: "#e03c32", marginBottom: 12 }}>{error}</div>}
        {success && <div style={{ color: "#23a262", marginBottom: 12 }}>{success}</div>}
        <button
          onClick={handleSubmitJob}
          disabled={posting}
          style={{
            width: 240,
            height: 50,
            fontSize: 18,
            fontWeight: 700,
            background: posting ? "#b6d4fa" : "#2684ff",
            color: "#fff",
            border: "none",
            borderRadius: 8,
            cursor: posting ? "not-allowed" : "pointer"
          }}
        >
          {posting ? "Updating..." : "Update Job"}
        </button>
        <button
          onClick={onCancel}
          disabled={posting}
          style={{
            marginLeft: 24,
            width: 110,
            height: 50,
            fontSize: 18,
            fontWeight: 700,
            background: "#f3f6fc",
            color: "#1460b6",
            border: "1.5px solid #b7c4d8",
            borderRadius: 8,
            cursor: posting ? "not-allowed" : "pointer"
          }}
        >
          Cancel
        </button>
      </div>
    </div>
  );
}